<div class="online-menu-nav-for-desktop" [ngClass]="{'is-searching': isOpen}">
    <shared-search-for-products-filter (onToggleOpen)="handleSearchToggle($event)" [open]="isOpen"
        class="online-menu-nav-for-desktop__search">
    </shared-search-for-products-filter>

    <shared-sub-nav-for-expanded @enterComponent [registryId]="registryId" *ngIf="!isOpen"
        [pages]="onlineMenuPages$ | async" class="online-menu-nav-for-desktop__subnav">
    </shared-sub-nav-for-expanded>

    <shared-sub-nav-for-collapsed @enterComponent class="online-menu-nav-for-desktop__subnav-collapsed"
        [registryId]="registryId" *ngIf="isOpen" [pages]="onlineMenuPages$ | async">
    </shared-sub-nav-for-collapsed>
</div>